export const FETCH_CURRENCY_LIST = 'FETCH_CURRENCY_LIST';
export const FETCH_CURRENCY_RATES = 'FETCH_CURRENCY_RATES';
